import { render } from "./SportsStoreEditor.vue?vue&type=template&id=566e5682"
import script from "./SportsStoreEditor.vue?vue&type=script&lang=js"
export * from "./SportsStoreEditor.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__